export function priceDifferenceInPercentage(oldPrice, newPrice) {
  return ((oldPrice - newPrice) / oldPrice) * 100;
}
